import classes from './CopyLinkField.module.css';
import Button from '../buttons/button/Button';
import NotificationManager from 'react-notifications/lib/NotificationManager';
import Strings from 'values/Strings';
import { FiCopy } from 'react-icons/fi';

const CopyLinkField = ({ link }) => {

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(link);
            NotificationManager.success('Ссылка скопирована в буфер обмена', Strings.notificationsSuccessTitle, 2000);
        } catch (error) {
            // Fallback для старых браузеров
            const textArea = document.createElement('textarea');
            textArea.value = link;
            textArea.style.position = 'fixed';
            textArea.style.opacity = '0';
            document.body.appendChild(textArea);
            textArea.select();
            try {
                document.execCommand('copy');
                NotificationManager.success('Ссылка скопирована в буфер обмена', Strings.notificationsSuccessTitle, 2000);
            } catch (err) {
                NotificationManager.error('Не удалось скопировать ссылку', Strings.notificationsErrorTitle, 2000);
            }
            document.body.removeChild(textArea);
        }
    };

    return (
        <div className={classes.linkFieldContainer}>
            <div className={classes.description}>
                <p className={classes.descriptionText}>
                    Для редактирования кейса в дальнейшем необходимо скопировать и сохранить эту ссылку.
                </p>
            </div>
            <div className={classes.linkContainer}>
                <input
                    type="text"
                    value={link}
                    readOnly
                    className={classes.linkInput}
                />
                <Button
                    onClick={handleCopy}
                    className={classes.copyButton}
                >
                   <>
                            <FiCopy className={classes.icon} />
                            <span>Скопировать</span>
                        </>
                </Button>
            </div>
        </div>
    );
};

export default CopyLinkField;

